"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANALYTICS_DISPLAY_NAME_SCRIPT_GLOBAL_NAMES = exports.ANALYTICS_DISPLAY_NAME_VARIABLE_NAMES = exports.ANALYTICS_SCRIPT_GLOBAL_NAMES = void 0;
exports.textUsesAnalyticsScriptGlobals = textUsesAnalyticsScriptGlobals;
exports.textUsesAnalyticsDisplayNameSurface = textUsesAnalyticsDisplayNameSurface;
/**
 * Public analytics-related globals exposed to adventure scripts (read-only context + effects).
 *
 * When you add or rename a helper that reads from the analytics snapshot in
 * `ScriptContext.ts` (or otherwise must trigger `AnalyticsScriptService.refreshSnapshot()`),
 * add its identifier here so static scanning and refresh gating stay correct.
 */
exports.ANALYTICS_SCRIPT_GLOBAL_NAMES = [
    'getAnalyticsTopUsers',
    'getAnalyticsTotalInteractions',
    'getAnalyticsTopFeedbackUsers',
    'getAnalyticsTotalFeedback',
    'getAnalyticsRecentFeedback',
    'getAnalyticsRecentGeneralFeedback',
    'getAnalyticsFeedbackAdventures',
    'getAnalyticsRecentFeedbackForAdventure',
    'generateAnalyticsFeedbackCards',
    'generateAnalyticsFeedbackGeneralCards',
    'generateAnalyticsFeedbackCardsForAdventure',
    'getAnalyticsFeedbackAdventureTitleMarkup',
    'generateAnalyticsFeedbackAdventureOptions',
];
let cachedGlobalNamePattern = null;
function getAnalyticsGlobalNamePattern() {
    if (!cachedGlobalNamePattern) {
        cachedGlobalNamePattern = new RegExp(`\\b(?:${exports.ANALYTICS_SCRIPT_GLOBAL_NAMES.join('|')})\\b`);
    }
    return cachedGlobalNamePattern;
}
function textUsesAnalyticsScriptGlobals(text) {
    if (text === undefined || text === null) {
        return false;
    }
    const s = typeof text === 'string' ? text : String(text);
    if (!s) {
        return false;
    }
    return getAnalyticsGlobalNamePattern().test(s);
}
/**
 * Player variable names and effect helpers that require syncing per-user analytics fields
 * (`user_analytics_display_name`, `user_analytics_feedback_count`) from the analytics server
 * before scene display or option processing.
 */
exports.ANALYTICS_DISPLAY_NAME_VARIABLE_NAMES = [
    'user_analytics_display_name',
    'user_analytics_feedback_count',
    'analytics_alias_input',
    'user_analytics_alias_update_status',
    'user_analytics_alias_update_error',
];
/**
 * Effect-only helpers that read or write analytics display-name state.
 * Add identifiers here when you introduce new alias-related script APIs.
 */
exports.ANALYTICS_DISPLAY_NAME_SCRIPT_GLOBAL_NAMES = ['setAnalyticsDisplayName'];
let cachedDisplayNameSurfacePattern = null;
function getAnalyticsDisplayNameSurfacePattern() {
    if (!cachedDisplayNameSurfacePattern) {
        const names = [
            ...exports.ANALYTICS_DISPLAY_NAME_SCRIPT_GLOBAL_NAMES,
            ...exports.ANALYTICS_DISPLAY_NAME_VARIABLE_NAMES,
        ];
        cachedDisplayNameSurfacePattern = new RegExp(`\\b(?:${names.join('|')})\\b`);
    }
    return cachedDisplayNameSurfacePattern;
}
function textUsesAnalyticsDisplayNameSurface(text) {
    if (text === undefined || text === null) {
        return false;
    }
    const s = typeof text === 'string' ? text : String(text);
    if (!s) {
        return false;
    }
    return getAnalyticsDisplayNameSurfacePattern().test(s);
}
//# sourceMappingURL=analyticsScriptSurface.js.map